import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ejpbz22sm: FaireProductEntity = {
  token: "p_7ejpbz22sm",
  type: "product",
  name: "Grateful Dead Dancing Bears Pin Set",
  brandToken: "b_c0o4zzgc",
  brandName: "Hiouchi Jewels | Rose & Bolt Grateful Dead Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/42dacc8a3a129dee2974c958ebedaa0fde825bb863ffed693cd95beb51aaa424.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35bf00ff942e16de59a0aa5d23f163e7e72cb610fcd888cd5196a0f82b146cc8.jpeg",
    "https://cdn.faire.com/fastly/dcfbf8ffea3bf77cb36731a56e13e9fed6ae76a38722f95c23a4cd20045e6985.jpeg",
    "https://cdn.faire.com/fastly/69e6987eee9584483f69276f4b1be76dae57c5ae275cb0a957ca3286e37ee1d4.jpeg",
    "https://cdn.faire.com/fastly/81d3fa9e925e94e66eee2def694e01c7e89ead723303fc6f4de35c9ea3c856c5.jpeg",
    "https://cdn.faire.com/fastly/bc0f15c6e2ff428ee1321aba3d015f6aa794ddcc06c0cc5a8ed8a906035146e8.jpeg",
    "https://cdn.faire.com/fastly/80af70feeadf60c41b93086f2b9a51dc4e2977c51c8072b55e32345734c7ec79.jpeg",
    "https://cdn.faire.com/fastly/088be5741b30077940bdcf0b134432da612984ced761f6f86bcb32bf3e1461c8.jpeg",
  ],
  priceDollars: 37.2,
  description:
    '~ A Set of 5 Grateful Dead Dancing Bear pins.\n~ Gold plated with colored enamel, honoring the iconic logo, which originated on the Bear\'s Choice ~ album.\n~ Pins come on a beautiful collectors card, designed by psychedelic artist Ellie Paisley.\n~ Bear Pins measure 31mm in height.&nbsp;&nbsp;\n~ Card measures 5.75" x 4"\n~ Pins feature 2 posts each, with multicolored round and star shaped silicone backs.\n~ Officially Licensed Grateful Dead TM&amp;©2024GDP',
  tags: [],
  msrpDollars: 79.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:12.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
